import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/react/react/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import data from '../../src/FormControl/FormControl.docs.json';
import { FormControl, TextInputWithTokens, Autocomplete, Select, Textarea, Checkbox, CheckboxGroup, Radio, RadioGroup, Text } from '@primer/react';
import { MarkGithubIcon } from '@primer/octicons-react';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Note = makeShortcode("Note");
const ComponentProps = makeShortcode("ComponentProps");
const ComponentChecklist = makeShortcode("ComponentChecklist");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h2>{`Examples`}</h2>
    <h3>{`Basic`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<FormControl>
  <FormControl.Label>Name</FormControl.Label>
  <TextInput />
</FormControl>
`}</code></pre>
    <h3>{`With complex inputs`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline",
        "live": true,
        "noinline": true
      }}>{`const DifferentInputs = () => {
  const [tokens, setTokens] = React.useState([
    {text: 'zero', id: 0},
    {text: 'one', id: 1},
    {text: 'two', id: 2},
  ])
  const onTokenRemove = tokenId => {
    setTokens(tokens.filter(token => token.id !== tokenId))
  }

  return (
    <Box display="grid" gridGap={3}>
      <FormControl>
        <FormControl.Label>TextInputWithTokens</FormControl.Label>
        <TextInputWithTokens onTokenRemove={onTokenRemove} tokens={tokens} />
      </FormControl>
      <FormControl>
        <FormControl.Label>Autocomplete</FormControl.Label>
        <Autocomplete>
          <Autocomplete.Input block />
          <Autocomplete.Overlay>
            <Autocomplete.Menu
              items={[
                {text: 'css', id: 0},
                {text: 'css-in-js', id: 1},
                {text: 'styled-system', id: 2},
                {text: 'javascript', id: 3},
                {text: 'typescript', id: 4},
                {text: 'react', id: 5},
                {text: 'design-systems', id: 6},
              ]}
              selectedItemIds={[]}
            />
          </Autocomplete.Overlay>
        </Autocomplete>
      </FormControl>
      <FormControl>
        <FormControl.Label>Select</FormControl.Label>
        <Select>
          <Select.Option value="figma">Figma</Select.Option>
          <Select.Option value="css">Primer CSS</Select.Option>
          <Select.Option value="prc">Primer React components</Select.Option>
          <Select.Option value="pvc">Primer ViewComponents</Select.Option>
        </Select>
      </FormControl>
      <FormControl>
        <FormControl.Label>Textarea</FormControl.Label>
        <Textarea />
      </FormControl>
    </Box>
  )
}

render(DifferentInputs)
`}</code></pre>
    <h3>{`With a custom input`}</h3>
    <Note variant="warning" mdxType="Note">
      <p>{`When rendering an input other than a form component from Primer, you must manually pass the attributes that make the form control accessible:`}</p>
      <ul>
        <li parentName="ul">{`The input should have an ID`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`FormControl.Label`}</inlineCode>{` should be associated with the text input by using `}<inlineCode parentName="li">{`htmlFor`}</inlineCode></li>
        <li parentName="ul">{`If there is a caption, the input should be associated with the caption by passing the message's ID to `}<inlineCode parentName="li">{`aria-describedby`}</inlineCode></li>
        <li parentName="ul">{`If there is a validation message, the input should be associated with the message by passing the message's ID to `}<inlineCode parentName="li">{`aria-describedby`}</inlineCode></li>
        <li parentName="ul">{`If there is both a caption and a validation message, the input should be associated with the message by passing the both the validation message's ID and the caption's ID to `}<inlineCode parentName="li">{`aria-describedby`}</inlineCode>{`. Example: `}<inlineCode parentName="li">{`aria-describedby="caption-id validation-id"`}</inlineCode></li>
        <li parentName="ul">{`If the input's value is invalid, `}<inlineCode parentName="li">{`aria-invalid={true}`}</inlineCode>{` should be passed to the input.`}</li>
        <li parentName="ul">{`If the input is disabled, `}<inlineCode parentName="li">{`disabled`}</inlineCode>{` should be passed.`}</li>
        <li parentName="ul">{`If the input is required, `}<inlineCode parentName="li">{`required`}</inlineCode>{` should be passed.`}</li>
      </ul>
      <p>{`When rendering a custom checkbox or radio component, you must also pass `}<inlineCode parentName="p">{`layout="horizontal"`}</inlineCode>{` to the `}<inlineCode parentName="p">{`FormControl`}</inlineCode>{` component.`}</p>
    </Note>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline",
        "live": true,
        "noinline": true
      }}>{`const CustomTextInput = props => <input type="text" {...props} />
const CustomCheckboxInput = props => <input type="checkbox" {...props} />
const FormControlWithCustomInput = () => {
  const [value, setValue] = React.useState('mona lisa')
  const [validationResult, setValidationResult] = React.useState()
  const doesValueContainSpaces = inputValue => /\\s/g.test(inputValue)
  const handleInputChange = e => {
    setValue(e.currentTarget.value)
  }

  React.useEffect(() => {
    if (doesValueContainSpaces(value)) {
      setValidationResult('noSpaces')
    } else if (value) {
      setValidationResult('validName')
    }
  }, [value])

  return (
    <Box display="grid" gridGap={3}>
      <FormControl>
        <FormControl.Label htmlFor="custom-input">GitHub handle</FormControl.Label>
        <CustomTextInput
          id="custom-input"
          aria-describedby="custom-input-caption custom-input-validation"
          aria-invalid={validationResult === 'noSpaces'}
          onChange={handleInputChange}
        />
        {validationResult === 'noSpaces' && (
          <FormControl.Validation id="custom-input-validation" variant="error">
            GitHub handles cannot contain spaces
          </FormControl.Validation>
        )}
        {validationResult === 'validName' && (
          <FormControl.Validation id="custom-input-validation" variant="success">
            Valid name
          </FormControl.Validation>
        )}
        <FormControl.Caption id="custom-input-caption">
          With or without "@". For example "monalisa" or "@monalisa"
        </FormControl.Caption>
      </FormControl>

      <CheckboxGroup>
        <CheckboxGroup.Label>Checkboxes</CheckboxGroup.Label>
        <FormControl layout="horizontal">
          <CustomCheckboxInput id="custom-checkbox-one" value="checkOne" />
          <FormControl.Label htmlFor="custom-checkbox-one">Checkbox one</FormControl.Label>
          <FormControl.Caption id="custom-checkbox-one-caption">Hint text for checkbox one</FormControl.Caption>
        </FormControl>
        <FormControl layout="horizontal">
          <CustomCheckboxInput id="custom-checkbox-two" value="checkTwo" />
          <FormControl.Label htmlFor="custom-checkbox-two">Checkbox two</FormControl.Label>
          <FormControl.Caption id="custom-checkbox-two-caption">Hint text for checkbox two</FormControl.Caption>
        </FormControl>
      </CheckboxGroup>
    </Box>
  )
}

render(FormControlWithCustomInput)
`}</code></pre>
    <h3>{`With checkbox and radio inputs`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Box display="grid" sx={{gap: 3}}>
  <CheckboxGroup>
    <CheckboxGroup.Label>Checkboxes</CheckboxGroup.Label>
    <FormControl>
      <Checkbox value="checkOne" />
      <FormControl.Label>Checkbox one</FormControl.Label>
    </FormControl>
    <FormControl>
      <Checkbox value="checkTwo" />
      <FormControl.Label>Checkbox two</FormControl.Label>
    </FormControl>
    <FormControl>
      <Checkbox value="checkThree" />
      <FormControl.Label>Checkbox three</FormControl.Label>
    </FormControl>
  </CheckboxGroup>

  <RadioGroup>
    <RadioGroup.Label>Radios</RadioGroup.Label>
    <FormControl>
      <Radio name="radioChoices" value="radioOne" />
      <FormControl.Label>Radio one</FormControl.Label>
    </FormControl>
    <FormControl>
      <Radio name="radioChoices" value="radioTwo" />
      <FormControl.Label>Radio two</FormControl.Label>
    </FormControl>
    <FormControl>
      <Radio name="radioChoices" value="radioThree" />
      <FormControl.Label>Radio three</FormControl.Label>
    </FormControl>
  </RadioGroup>
</Box>
`}</code></pre>
    <h3>{`Required`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<FormControl required>
  <FormControl.Label>Name</FormControl.Label>
  <TextInput />
</FormControl>
`}</code></pre>
    <Note mdxType="Note">
  Checkbox and radio form controls cannot be required individually. Instead, you can require a selection from the entire
  group of checkboxes or radios.
    </Note>
    <h3>{`Disabled`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Box display="grid" gridGap={3}>
  <FormControl disabled>
    <FormControl.Label>Name</FormControl.Label>
    <TextInput />
  </FormControl>

  <FormControl disabled>
    <FormControl.Label>Checkbox option</FormControl.Label>
    <Checkbox />
  </FormControl>
</Box>
`}</code></pre>
    <h3>{`With a visually hidden label`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Box display="grid" gridGap={3}>
  <FormControl>
    <FormControl.Label visuallyHidden>Name</FormControl.Label>
    <TextInput />
  </FormControl>
  <FormControl>
    <FormControl.Label visuallyHidden>Checkbox option</FormControl.Label>
    <Checkbox />
  </FormControl>
</Box>
`}</code></pre>
    <Note mdxType="Note">
      <p>{`We encourage using `}<inlineCode parentName="p">{`FormControl`}</inlineCode>{` alongside all standalone form components like `}<a parentName="p" {...{
          "href": "/TextInput"
        }}><inlineCode parentName="a">{`TextInput`}</inlineCode></a>{`, as every input must have a corresponding label to be accessible to assistive technology.`}</p>
      <p><inlineCode parentName="p">{`FormControl`}</inlineCode>{` also provides an interface for showing a hint text caption and a validation message, and associating those with the input for assistive technology.`}</p>
    </Note>
    <h3>{`With a caption`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<Box display="grid" gridGap={3}>
  <FormControl>
    <FormControl.Label>Name</FormControl.Label>
    <TextInput />
    <FormControl.Caption>Hint: your first name</FormControl.Caption>
  </FormControl>
  <FormControl>
    <FormControl.Label>Option one</FormControl.Label>
    <Checkbox />
    <FormControl.Caption>Hint: the first and only option</FormControl.Caption>
  </FormControl>
</Box>
`}</code></pre>
    <h3>{`With validation`}</h3>
    <Note mdxType="Note">Validation messages are not used for an individual checkbox or radio form control.</Note>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "live noinline",
        "live": true,
        "noinline": true
      }}>{`const ValidationExample = () => {
  const [value, setValue] = React.useState('mona lisa')
  const [validationResult, setValidationResult] = React.useState()
  const doesValueContainSpaces = inputValue => /\\s/g.test(inputValue)
  const handleInputChange = e => {
    setValue(e.currentTarget.value)
  }

  React.useEffect(() => {
    if (doesValueContainSpaces(value)) {
      setValidationResult('noSpaces')
    } else if (value) {
      setValidationResult('validName')
    }
  }, [value])

  return (
    <FormControl>
      <FormControl.Label>GitHub handle</FormControl.Label>
      <TextInput block value={value} onChange={handleInputChange} />
      {validationResult === 'noSpaces' && (
        <FormControl.Validation variant="error">GitHub handles cannot contain spaces</FormControl.Validation>
      )}
      {validationResult === 'validName' && (
        <FormControl.Validation variant="success">Valid name</FormControl.Validation>
      )}
      <FormControl.Caption>With or without "@". For example "monalisa" or "@monalisa"</FormControl.Caption>
    </FormControl>
  )
}

render(ValidationExample)
`}</code></pre>
    <h3>{`With a leading visual`}</h3>
    <Note mdxType="Note">Only a checkbox or radio form control may have a leading visual.</Note>
    <pre><code parentName="pre" {...{
        "className": "language-jsx",
        "metastring": "live",
        "live": true
      }}>{`<>
  <FormControl>
    <FormControl.Label>Option one</FormControl.Label>
    <FormControl.LeadingVisual>
      <MarkGithubIcon />
    </FormControl.LeadingVisual>
    <Checkbox />
  </FormControl>

  <FormControl>
    <FormControl.Label>Option two</FormControl.Label>
    <FormControl.LeadingVisual>
      <MarkGithubIcon />
    </FormControl.LeadingVisual>
    <Checkbox />
    <FormControl.Caption>This one has a caption</FormControl.Caption>
  </FormControl>
</>
`}</code></pre>
    <h2>{`Props`}</h2>
    <ComponentProps data={data} mdxType="ComponentProps" />
    <h2>{`Component status`}</h2>
    <ComponentChecklist items={{
      propsDocumented: true,
      noUnnecessaryDeps: true,
      adaptsToThemes: true,
      adaptsToScreenSizes: true,
      fullTestCoverage: true,
      usedInProduction: false,
      usageExamplesDocumented: true,
      hasStorybookStories: true,
      designReviewed: false,
      a11yReviewed: true,
      stableApi: false,
      addressedApiFeedback: false,
      hasDesignGuidelines: false,
      hasFigmaComponent: false
    }} mdxType="ComponentChecklist" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      